import { Route } from "@/models/Route.model";

export const clientRoutes = {
  elgiganten: {
    f1: {
      path: "/elgiganten",
      label: "Elgiganten F1 25",
    } as Route,
  },
  legof1: {
    f1: {
      path: "/legoxf1",
      label: "Lego X F1",
    } as Route,
  },
  legobtp: {
    f1: {
      path: "/legobtp",
      label: "Lego Beat The Pro",
    } as Route,
  },
  logitech: {
    fm: {
      path: "/logitech",
      label: "LOGITECH",
    } as Route,
  },
  racedays: {
    fm: {
      path: "/racedays/:slug",
      label: "LOGITECH RACE DAYS",
    } as Route,
  },
  tcltt: {
    tt: {
      path: "/tcl-tt",
      label: "TCL Time Trial",
    } as Route,
  },
  jbltt: {
    tt: {
      path: "/jbl-tt",
      label: "JBL Time Trial",
    } as Route,
  },
  keychrontt: {
    tt: {
      path: "/keychron-tt",
      label: "KEYCHRON Time Trial",
    } as Route,

    ttv: {
      path: "/keychron-ttv",
      label: "KEYCHRON Time Trial vertical",
    } as Route,

    ts: {
      path: "/keychron-ts",
      label: "KEYCHRON Typing Shooter",
    } as Route,

    timetrial: {
      path: "/keychron-time-trial",
      label: "KEYCHRON Time Trail",
    } as Route,
    "samsung-racing": {
      path: "/samsung-racing",
      label: "Samsung Racing",
    } as Route,
  },
  samsung: {
    base: {
      path: "/samsung",
      label: "Samsung",
    } as Route,
  },
  list: {
    path: "/list",
    label: "list of all clients",
  } as Route,
};
